import { AssetEntity } from 'src/modules/assets';
import _ from 'lodash';
import React, { useCallback } from 'react';
import { Col, Row } from 'antd';
import classnames from 'classnames';

import { isSmallScreen } from 'src/utils/breakpoints';
import { FileNameAndThumbnail } from 'src/modules/products/components/downloads/FileAndThumbnail/FileNameAndThumbnail';
import { FileMetadata } from 'src/modules/products/components/downloads/FileMetadata/FileMetadata';
import { GlobalIcon, IconImage } from 'src/modules/global';
import { Media } from 'react-breakpoints';
import styles from './AssetRow.module.scss';
import { FormattedMessage } from 'react-intl';
import { makeApiUrl } from 'src/utils/url';
import { LinkWithIcon } from '../LinkWithIcon/LinkWithIcon';

export interface AssetRowProps {
  asset: AssetEntity;
  onPreviewClick: (asset: AssetEntity) => void;
  className?: string;
  enablePreview?: boolean;
  showMetadata?: boolean;
}

export const AssetRow = ({
  asset,
  onPreviewClick,
  enablePreview = false,
  showMetadata = false,
}: AssetRowProps) => {
  const handlePreviewClick = useCallback(() => {
    onPreviewClick(asset);
  }, [asset, onPreviewClick]);

  return (
    <Media>
      {({ currentBreakpoint } = { currentBreakpoint: 'xs' }) => {
        return (
          <Row key={asset.id} className={classnames(`type-${asset.type}`, styles.assetRow, 'row')}>
            <Col md={12} sm={14} xs={12}>
              <FileNameAndThumbnail
                asset={asset}
                onClick={
                  !isSmallScreen(currentBreakpoint) && enablePreview ? handlePreviewClick : null
                }
              />
            </Col>
            <Col md={12} sm={10} xs={12}>
              <div className={styles.fileMetadataAndActions}>
                {showMetadata && <FileMetadata asset={asset} className={styles.fileMetadata} />}
                <div className={styles.largeScreenActions}>
                  {!isSmallScreen(currentBreakpoint) && enablePreview && (
                    <LinkWithIcon
                      onClick={handlePreviewClick}
                      icon={<GlobalIcon image={IconImage.Preview} />}
                      className={styles.buttonPreview}>
                      <FormattedMessage id="products/downloads/listing/action/preview" />
                    </LinkWithIcon>
                  )}
                  <LinkWithIcon
                    href={makeApiUrl(`/assets/download/${asset.id}`)}
                    icon={<GlobalIcon image={IconImage.Download} />}
                    className={styles.buttonDownload}>
                    <div className={styles.dowloadLabel}>
                      <FormattedMessage id="products/downloads/listing/action/download" />
                    </div>
                  </LinkWithIcon>
                </div>
              </div>
            </Col>
          </Row>
        );
      }}
    </Media>
  );
};
